export function moneyMaskToFloat(value) {
    var formated = value.replaceAll('.', '');
    formated = formated.replaceAll(',', '.');
    return parseFloat(formated);
}
